import {useSelector} from "react-redux";

import _ from "lodash";
import moment from "moment";

import {LOCALES} from "src/i18n/locales";

const useLocale = () => {
  const {
    currentLanguage: {code: langCode}
  } = useSelector((state) => state.multiLanguage);

  // format {message: {vi: "vietnamese", en: "english"}}
  const renderContentByLangType1 = (content) => {
    if (!content || _.isEmpty(content)) return "UNKNOWN";
    switch (langCode) {
      case LOCALES.ENGLISH.code:
        return content.en || content.vi;
      case LOCALES.VIETNAMESE.code:
        return content.vi || content.en;
      default:
        return content.vi || content.en;
    }
  };
  // format {message: "vietnamese", message_en: "english"}
  const renderContentByLangType2 = (main, varName = "content") => {
    if (!main || _.isEmpty(main)) return "UNKNOWN";
    switch (langCode) {
      case LOCALES.ENGLISH.code:
        return main[`${varName}_en`] || main[`${varName}`];
      case LOCALES.VIETNAMESE.code:
        return main[`${varName}`] || main[`${varName}_en`];
      default:
        return main[`${varName}`] || main[`${varName}_en`];
    }
  };

  const calcRelativeNotifyTime = (notifyTime) => {
    const from = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
    const to = moment(notifyTime, "YYYY-MM-DD HH:mm:ss");
    // eslint-disable-next-line no-underscore-dangle
    const duration = moment.duration(from.diff(to))._data;
    const rtf1 = new Intl.RelativeTimeFormat(langCode || "vi-VN", {
      style: "long"
    });
    if (duration.years > 0) {
      return rtf1.format(-duration.years, "year");
    }
    if (duration.months > 0) {
      return rtf1.format(-duration.months, "month");
    }
    if (duration.days > 0) {
      return rtf1.format(-duration.days, "day");
    }
    if (duration.hours > 0) {
      return rtf1.format(-duration.hours, "hour");
    }
    if (duration.minutes > 0) {
      return rtf1.format(-duration.minutes, "minute");
    }
    if (duration.seconds > 0) {
      return rtf1.format(-duration.seconds, "second");
    }
    return "Just now";
  };
  return {renderContentByLangType1, renderContentByLangType2, calcRelativeNotifyTime};
};

export default useLocale;
